const endpointsPath = {
    auth: 'Auth',
    auditLog: 'AuditLog',
    order: 'Order',
    category: 'Category',
    subCategory: 'SubCategory',
    productType: 'ProductType',
    productSubType: 'ProductSubType',
    brand: 'Brand',
    tag: 'Tag',
    taggedProduct: 'TaggedProduct',
    product: 'Products',
    featuredProduct: 'FeaturedProduct',
    transaction: 'Transaction',
    productImage: 'ProductImage',
    productVariant: 'ProductVariant',
    productSpecification: 'ProductSpecification',
    pricingTier: 'PricingTier',
    profile: 'UserProfile',
    shipping: 'Shipping',
    userFavorite: 'user/favorite',
    store: 'store',
    propertyRecent: 'store/properties/recent',
    productAdmin: 'admin/product',
    property: 'property',
    propertyAdmin: 'admin/property',
    userAdmin: 'admin/user',
    wallet: 'Wallet',
    bankAccount: 'BankAccount',
    banner: 'Banner',
    user: 'User',
    deliveryLocation: 'DeliveryLocation',
    shippingProviders: 'Shipping/providers',
    vat: 'Vat',
    referral: 'Referral',
    subscriber: 'Subscriber',
    referralCommission: 'ReferralCommission',
    coupon: 'Coupon',
    manualPayment: 'ManualPayment',
    paymentMethodConfiguration: 'PaymentMethodConfiguration',

}
export default endpointsPath
